import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, of, tap } from 'rxjs';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { Tc } from '../../../../core/_infrastructure/types/common';
import { TratamientoDesinfeccionService } from '../tratamientodesinfeccion.service';
import { TTratamientoCamViewModel } from '../tratamientodesinfeccion.types';

@Component({
    selector: 'app-tratamientodesinfeccion-wrapper-edit',
    templateUrl: './tratamientodesinfeccion-wrapper-edit.component.html',
})
export class TratamientoDesinfeccionWrapperEditComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    tratamientoDesinfeccion: TTratamientoCamViewModel;
    formGroup: FormGroup;
    campanias: Tc[];

    listUrl = '/mantenimiento/general/tratamientodesinfeccion';
    successMessage = 'Registro modificado correctamente';
    messageErrorAlreadyExist = 'Registro existente';

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const id: any = params.get('id');
        if (id) {
            this.getTratamientoDesinfeccion(id);
        }
    });

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private tratamientoDesinfeccionService: TratamientoDesinfeccionService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        private globalService: GlobalService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.preparePresentation();
        this.getCampanias();
    }

    private getCampanias(): void {
        this.globalService.getAllCampanias().subscribe((campanias: Tc[]) => {
            this.campanias = campanias;
        });
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                Id: [null],
                IdCampania: [null, Validators.required],
                FechaCreacion: null,
                FechaBaja: null,
                Activo: true,
                Tratamiento: '',
                ProductoQuimico: '',
                Concentracion: '',
                Duracion: '',
                Temperatura: '',
                Fecha: [null],
                InformacionAdicional: '',
            }),
        });
    }

    private getTratamientoDesinfeccion(id: number): void {
        this.tratamientoDesinfeccionService
            .getTratamientoDesinfeccion(id)
            .pipe(
                tap((t: TTratamientoCamViewModel) => {
                    this.tratamientoDesinfeccion = t;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.formGroup.disable();
                    return of([]);
                }),
            )
            .subscribe();
    }
    onSave(): void {
        this.visibilitySpinner = true;
        const model = { ...this.formGroup.value.basic };

        model.FechaCreacion = this.tratamientoDesinfeccion?.FechaCreacion;
        model.FechaBaja = this.tratamientoDesinfeccion?.FechaBaja;

        this.tratamientoDesinfeccionService
            .saveTratamientoDesinfeccion(model)
            .pipe(
                tap(res => {
                    this.visibilitySpinner = false;
                    this.addSuccessMessage(this.successMessage);
                    this.onBack();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    if (error?.message?.indexOf(this.messageErrorAlreadyExist) != -1) {
                        this.formGroup.disable();
                    }
                    return of([]);
                }),
            )
            .subscribe();
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }

    get formInvalid(): boolean {
        return !this.formGroup.valid || !this.formGroup.dirty || this.formGroup.pristine;
    }
}
